var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detailInfo && _vm.detailInfo.if_chain)?_c('div',{staticClass:"main-content"},[_c('flex-line',{attrs:{"is-link":true,"show-border":true},nativeOn:{"click":function($event){return _vm.$router.push({name:'HomeChainList',query:{goods_id:_vm.detailInfo.goods_id}})}}},[_c('span',[_vm._v("自提门店")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }